import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { IAppState } from '../app.state';
import { of } from 'rxjs';

import { ToastrConfigs } from "../../@core/data/toastr-config";
import { NbToastrService } from "@nebular/theme";

import { CompanyService } from '../../@core/data/company/company.service';
import { CompanyLogoError, CompanyLogoLoaded, CompanyLogoRequested } from './companyLogo.actions';

@Injectable()
export class CompanyLogoEffects {
  constructor(
    private actions$: Actions,
    private store: Store<IAppState>,
    private toastrService : NbToastrService,
    private companyService: CompanyService
  ) {}

  requestCompanyLogo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyLogoRequested),
      mergeMap(() =>
        this.companyService.getCompanyLogo().pipe(
          map((res: any) => {
            return res.status ? CompanyLogoLoaded({ logo: res?.data }) : CompanyLogoLoaded({logo: null})
        }),
          catchError((error: any) => of(CompanyLogoError()))
        ) 
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CompanyLogoError),
        tap(() => {
        })
      ),
    { dispatch: false }
  );
}
